import { Component, OnInit, Injector } from '@angular/core';
import { Validators, FormGroup, FormControl } from '@angular/forms';
import { SubZoneService } from '../../../mesc.service';
import { SubZone } from '../../../../../shared/model';
import { MaintenanceService } from "../maintenance.service";

@Component({
  selector: 'app-subzone',
  templateUrl: './subzone.component.html',
  // styleUrls: ['./subzone.component.scss']
})
export class SubzoneComponent implements OnInit {
  private readonly maintenanceService: MaintenanceService;

  constructor(
    private SubZoneService: SubZoneService,
    private readonly injector: Injector,

  ) {
    this.maintenanceService = injector.get(MaintenanceService);
    this.maintenanceService.getCurrentPageValue();
  }

  isNew: boolean = false;
  editDataItem: SubZone;
  editForm = new FormGroup({
    Description: new FormControl("", Validators.required),
    DetailDescription: new FormControl(),
    CenterDescription: new FormControl(),
    Id: new FormControl(),
    CreatedDate: new FormControl(),
    CreatedBy: new FormControl(),
    ModifiedDate: new FormControl(),
    ModifiedBy: new FormControl(),
  });

  columns: any[] = [
    {
      field: "Description",
      title: "SubZone",
    }, {
      field: "DetailDescription",
      title: "Description",
    },
  ]

  onRead = () => {
    return this.SubZoneService.read('', true);
  }

  template = {
    controls: {
      add: true,
      edit: true,
      delete: true,
      excel: true,
    },
    columns: this.columns,
    service: this.SubZoneService,
    read: this.onRead,
    fileName: 'subzones.xlsx'
  }

  formDialog = {
    title: "SubZone",
    formControls: [
      {
        type: "text",
        name: "Description",
        title: "SubZone*",
        readonly: "never",
      },
      {
        type: "text",
        name: "DetailDescription",
        title: "Description*",
        readonly: "never",
      },
    ],
  }

  ngOnInit(): void {
    this.SubZoneService.query();
  }

  setModelHandler() {
    this.editDataItem = new SubZone();
  }
}